<script lang="ts" setup>
interface Props {
  variant?: 'full';
}

const props = defineProps<Props>();
</script>

<template>
  <div :class="[css.plusGrid, props.variant === 'full' && css.plusGridFull]" />
</template>

<style lang="scss" module="css">
.plusGrid {
  position: absolute;
  inset: calc(var(--plus) * 0.5);
  width: calc(100% - var(--plus));

  /* Controls */
  --cols: 12;
  --tile: calc(100cqw / (var(--cols) + 1) * 2);
  --plus: calc(var(--tile) * 0.5);
  --gap: var(--plus);
  --stroke: max(1px, calc(var(--plus) * 0.08));

  /* Height ≈ 50% but snap to tile size so nothing is cut off */
  block-size: 50%;
  align-self: end;
  height: 50%;

  @supports (height: round(1px, 1px)) {
    height: round(down, 50cqh, var(--tile));
  }

  padding: 0;
  background-origin: content-box;
  background-position: left bottom;
  background-repeat: repeat;
  background-size: calc(var(--tile) * 0.5);
  background-image: url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_491_13340)'%3E%3Cpath d='M12 24H36' stroke='white'/%3E%3Cpath d='M24 12V36' stroke='white'/%3E%3C/g%3E%3C/svg%3E%0A");
}

.plusGridFull {
  height: calc(100% - var(--plus));
}
</style>
